import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Static credentials
  const VALID_CREDENTIALS = {
    username: 'admin',
    password: 'admin123'
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (username === VALID_CREDENTIALS.username && password === VALID_CREDENTIALS.password) {
      // Store login state
      sessionStorage.setItem('isLoggedIn', 'true');
      sessionStorage.setItem('username', username);
      
      // Redirect to dashboard
      navigate('/dashboard');
    } else {
      setError('Invalid username or password. Please try again.');
    }
  };

  // Check if already logged in
  React.useEffect(() => {
    if (sessionStorage.getItem('isLoggedIn') === 'true') {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo">
          <a href="/">
            <img src="/assets/images/logo/logo.png" alt="Motorx Logo" />
          </a>
        </div>

        <h2 className="login-title">Admin Login</h2>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          <button type="submit" className="login-btn">Sign In</button>
        </form>

        <div className="login-footer">
          <p><a href="/">Back to Home</a></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
